import { put } from 'redux-saga/effects';
import { LocalStorageLoaded } from '../actions';

export function* loadFromLocalStorage(): Generator {
  try {
    const jwt = localStorage.getItem('jwt');
    const statesString = localStorage.getItem('states');

    const data: { jwt?: string; states?: Record<string, unknown> } = {};

    if (jwt) {
      data.jwt = jwt;
    }

    if (statesString) {
      try {
        data.states = JSON.parse(statesString);
      } catch {
        // Игнорируем ошибки парсинга states
      }
    }

    yield put(LocalStorageLoaded(data));
  } catch {
    // Игнорируем ошибки localStorage (например, если он отключён)
    yield put(LocalStorageLoaded({}));
  }
}
